import { Component, HostListener } from '@angular/core';
import { displayPayLink, removeIFrame, initializaDisplayPayLink, initializaConnectPayLink, displayConnectLink } from '../../assets/dollarpay.js'
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-roi-calculator-v4',
  templateUrl: './roi-calculator-v4.component.html',
})
export class RoiCalculatorV4Component {


  per_user_customer_base = 21500000;
  per_user_avg_trans_vol = 30;
  per_user_trans_per_year = 12;
  per_user_processing_fee = 2.9;
  per_user_percent_of_returns = 1;
  per_user_return_processing_fee = 25;


  tot_vol = 21500000;
  tot_trans = 640000;
  tot_fee_percent = 2.9;
  tot_fee_fixed = 0.30;
  tot_percent_of_returns = 1;
  tot_return_processing_fee = 25;
  tot_chargeback_year = 32000;


  volume = 10000001;
  percent = 2.90;
  adoption = 100;
  screen = 1;

  totalSavings = (this.volume * (this.percent / 100) * (this.adoption / 100)) - (this.volume * (1.3/100) * (this.adoption/100));

  constructor(public router: Router, private activeRoute: ActivatedRoute
  ) {

   
  }

  assumedRate = 1;


  adjustAdoption(rate: number) {


    this.adoption = rate;
    this.assumedRate = rate / 100;

  }


  switch(bit: number) {

    this.screen = bit

  }

  Convert(bit: any) {

    return Number(bit.split(',').join(''));




  }


  //CommaFormatted(event) {
  //  // skip for arrow keys
  //  if (event.which >= 37 && event.which <= 40) return;

  //  // format number
  //  if (this.product_price) {
  //    this.product_price = this.product_price.replace(/\D/g, "")
  //      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  //  }
  //}

  //numberCheck(args) {
  //  if (args.key === 'e' || args.key === '+' || args.key === '-') {
  //    return false;
  //  } else {
  //    return true;
  //  }
  //}







}
